import { Collapse } from 'bootstrap';
import { sizeFormat, loadingOverlay, scrollToElement } from "./utils";

$(document).ready(function(){
    var $form = $('#commentform');
    if(!$form.length){
        return;
    }
    
    var $modal = $('#respond-modal');
    var $modalTitle = $modal.find('.modal-title.no-reply');
    var $modalReplyTitle= $modal.find('#reply-title');
    var $commentField = $form.find('.acf-field-textarea textarea');
    var $fileFieldLabel = $form.find('.acf-field-file .acf-label label');
    var $fileFieldUploader = $form.find('.acf-field-file .acf-file-uploader');
    var $fileField = $form.find('input[name="acf[comment_file_key]"]');
    var $toggleChildren = $('.commentlist .toggle-children');
    var $children = $('.commentlist ul.children');
    
    // Set modal title based on comment type
    $modalReplyTitle.prependTo($modal.find('.modal-header'));
    $modal.on('show.bs.modal', function(e){
        if(e.relatedTarget && $(e.relatedTarget).hasClass('comment-reply-link')){
            $modalReplyTitle.removeClass('d-none');
            $modalTitle.addClass('d-none');
        }
        else {
            $modalReplyTitle.addClass('d-none');
            $modalTitle.removeClass('d-none');
        }
    });
    // Disable reply on popup close
    $modal.on('hide.bs.modal', function(e){
        $('#cancel-comment-reply-link').get(0).click();
    });
    
    // Children Comments collapse handler
    $children.collapse();
    setTimeout(function(){
        $children.collapse('hide');
        $children.addClass('initialized');
    }, 500);
    
    $toggleChildren.on('click', function(e){
        var children = $(this).parents('li.comment').first().children('.children');
        if(children.length){
            var collapse = Collapse.getOrCreateInstance(children.get(0));
            if($(this).hasClass('active') && collapse){
                collapse.hide();
                $(this).removeClass('active');
            }
            else {
                collapse.show();
                $(this).addClass('active');
            }
        }
        e.preventDefault();
        return false;
    });
    
    
    // Floating label fix for description
    $form.find('.acf-field-textarea').each(function(){
        $(this).find('.acf-label label').appendTo($(this).find('.acf-input'));
        $(this).find('.acf-label').remove();
    });
    
    // Expandable description field
    var minHeight = $commentField.height();
    $commentField.on('input', function(){
        $commentField.height(0);
        $commentField.height(Math.max($commentField.prop('scrollHeight'), minHeight));
    });
    
    // File selection click for Admin users
    $fileFieldLabel.on('click', function(e){
        var $mediaLink = $(this).parents('.acf-field-file').find('.acf-input a[data-name="add"]');
        if($mediaLink.length){
            $mediaLink.click();
            e.preventDefault();
            return false;
        }
    });
    
    // File selection field handler for non-Admin users
    if($fileFieldUploader.data('uploader') == 'basic'){
        var mime_types = $fileFieldUploader.data('mime_types').split(',');
        if(mime_types.length){
            $fileField.attr('accept', '.' + mime_types.join(',.'));
        }
        
        $fileField.on('change', function(e){
            if(this.files && this.files.length){
                var file = this.files[0];
                $fileFieldUploader.find('[data-name="title"], [data-name="filename"]').html(file.name);
                $fileFieldUploader.find('[data-name="filesize"]').html(sizeFormat(file.size));
                $fileFieldUploader.addClass('has-value');
            }
            else {
                $fileFieldUploader.removeClass('has-value');
            }
        });
    }
    
    // Form submit handler
    $form.on('submit', function(e){
        
        if (!this.checkValidity()) {
            $form.addClass('was-validated');
        }
        else if(!$form.hasClass('loading')) {
            loadingOverlay($form, true);
            
            var formData = new FormData(this);
            formData.set('action', 'ajaxcomments');
            $.ajax({
				type : 'POST',
				url : cmiscp_options.ajaxurl,
				data: formData,
                cache: false,
                contentType: false,
				enctype: 'multipart/form-data',
                processData: false,
                dataType: 'json',
				error: function (request, status, error) {
                    $form.prepend('<div class="alert alert-danger" role="alert">Error when submitting comment. Please try again later.</div>');
                    loadingOverlay($form, false);
                    $form.removeClass('was-validated');
				},
				success: function ( result ) {
                    if(result && result.error){
                        $form.prepend('<div class="alert alert-danger" role="alert">' + result.error + '</div>');
                        loadingOverlay($form, false);
                        $form.removeClass('was-validated');
                    }
                    else if(result && result.url){
                        $(window).off('beforeunload');
                        
                        // Force reload when only hash changed
                        $(window).on('hashchange',function(){ 
                            window.location.reload(true); 
                        });
                        
                        window.location = result.url;
                        
                    }
                    else {
                        $(window).off('beforeunload');
                        window.location.reload();
                    }
					
				}
			});
            
        }
        
        e.preventDefault();
        e.stopPropagation();
		return false;
    });
    
});

$(window).on('load', function(){
    // Scroll to comment from URL hash
    if(window.location.hash && window.location.hash.substring(0,7) == '#newcom'){
        var $block = $('#li-comment' + window.location.hash.substr(7));
        if($block.length) {
            $block.addClass('highlight');
            setTimeout(function(){
                $block.parents('ul.children').collapse('show');
                scrollToElement($block);
                setTimeout(function(){
                    $block.removeClass('highlight');
                }, 4000);
            }, 1000);
        }
    }
});